/* StackSchematic wordmark. Replaces the Backstage logo in the sidebar. */
import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles(theme => ({
  svg: { width: 'auto', height: 32 },
  mark: { fill: 'none', stroke: '#22B8CF', strokeWidth: 7, strokeLinejoin: 'round', strokeLinecap: 'round' },
  node: { fill: '#22B8CF' },
  word: { fill: theme.palette.common.white, fontSize: 46, fontWeight: 700, letterSpacing: -0.5 },
  wordAlt: { fill: '#22B8CF', fontSize: 46, fontWeight: 300, letterSpacing: -0.5 },
}));

export const LogoFull = () => {
  const classes = useStyles();
  return (
    <svg className={classes.svg} viewBox="0 0 430 90" xmlns="http://www.w3.org/2000/svg">
      {/* three stacked plates with a schematic trace running through them */}
      <g className={classes.mark}>
        <path d="M12 26 L44 10 L76 26 L44 42 Z" />
        <path d="M12 45 L44 61 L76 45" />
        <path d="M12 62 L44 78 L76 62" />
      </g>
      <circle className={classes.node} cx="44" cy="26" r="5" />
      <text className={classes.word} x="96" y="58">Stack</text>
      <text className={classes.wordAlt} x="215" y="58">Schematic</text>
    </svg>
  );
};
